import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreViewerToolbarComponent } from '@core/components/core-viewer-toolbar/core-viewer-toolbar.component';

@NgModule({
  declarations: [CoreViewerToolbarComponent],
  // TranslateModule va explícito: CoreCommonModule no lo exporta, y la barra
  // traduce sus propios textos (regresar y pantalla completa).
  imports: [CommonModule, TranslateModule],
  exports: [CoreViewerToolbarComponent]
})
export class CoreViewerToolbarModule {}
